import { Fragment } from 'react';
import { IconTooltip, Text } from '@pairy/pds-react';

import FeatureCell from '../FeatureCell';
import { PLAN_COLUMNS } from '../index.constants';
import { PlanFeatureRow, PlanKey } from '../index.types';
import * as Styled from '../index.styles';

interface Props {
  row: PlanFeatureRow;
  highlightedPlan?: PlanKey | null;
}

const FeatureRow = ({ row, highlightedPlan }: Props) => {
  return (
    <tr>
      <Styled.RowHeadCell scope="row">
        <Styled.LabelCell>
          <Text variant="md-regular" color="zinc_700">
            {row.label}
          </Text>
          {row.tooltip && (
            <IconTooltip
              iconProps={{
                icon: 'ph:question-fill',
                size: 17,
                color: 'zinc_400',
              }}
            >
              {row.tooltip.map((line, index) => (
                <Fragment key={line}>
                  {index > 0 && <br />}
                  {line}
                </Fragment>
              ))}
            </IconTooltip>
          )}
        </Styled.LabelCell>
      </Styled.RowHeadCell>

      {PLAN_COLUMNS.map((plan) => {
        const isHighlighted = plan === highlightedPlan;

        return (
          <td key={plan} className={isHighlighted ? 'is-highlighted' : ''}>
            <FeatureCell
              value={row.values[plan]}
              isHighlighted={isHighlighted}
            />
          </td>
        );
      })}
    </tr>
  );
};

export default FeatureRow;
